/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  PayableOverrides,
  BytesLike,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ThirdwebProxy, ThirdwebProxyInterface } from "../ThirdwebProxy";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_logic",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "constructor",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type ThirdwebProxyConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ThirdwebProxyConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ThirdwebProxy__factory extends ContractFactory {
  constructor(...args: ThirdwebProxyConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _logic: string,
    _data: BytesLike,
    overrides?: PayableOverrides & { from?: string | Promise<string> }
  ): Promise<ThirdwebProxy> {
    return super.deploy(
      _logic,
      _data,
      overrides || {}
    ) as Promise<ThirdwebProxy>;
  }
  getDeployTransaction(
    _logic: string,
    _data: BytesLike,
    overrides?: PayableOverrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_logic, _data, overrides || {});
  }
  attach(address: string): ThirdwebProxy {
    return super.attach(address) as ThirdwebProxy;
  }
  connect(signer: Signer): ThirdwebProxy__factory {
    return super.connect(signer) as ThirdwebProxy__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ThirdwebProxyInterface {
    return new utils.Interface(_abi) as ThirdwebProxyInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ThirdwebProxy {
    return new Contract(address, _abi, signerOrProvider) as ThirdwebProxy;
  }
}
